import _ from "lodash";
import { storageAvailable, getSellingPlan } from "../../../utils/functions";
import { logCaptureMessage } from "../../../utils/sentryLogger";

const modifyConstructorStorageNamespace = "modifyConstructorStorage";

export function filterOutMeals(data, types, dietType) {
  let skuPrefix = "";

  switch (dietType) {
    case "Mediterranean Plan":
      skuPrefix = "MD";
      break;
    case "Low-FODMAP Plan":
      skuPrefix = "LF";
      break;
    case "Diabetes Plan":
      skuPrefix = "DF";
      break;
    case "Gluten-Free Plan":
      skuPrefix = "GF";
      break;
    case "Heart-Friendly Plan":
      skuPrefix = "HF";
      break;
    case "Carb-Conscious Plan":
      skuPrefix = "CC";
      break;
    case "B2B Plan":
      skuPrefix = "B2B";
      break;
    case "Care Plan":
      skuPrefix = "MCD";
      break;
    default:
      skuPrefix = "LF";
  }

  return data.filter((meal) => {
    let found = false;
    let sameDietType = false;

    meal.tags.forEach((tag) => {
      types.forEach((type) => {
        if (tag.toLowerCase().includes(type)) {
          found = true;
          return true;
        }
      });
    });

    meal.variants.forEach((variant) => {
      if (variant.sku.startsWith(skuPrefix)) {
        sameDietType = true;
        return true;
      }
    });

    return found && sameDietType;
  });
}

export function markExcluded(products, exclusions) {
  let markedProducts = [...products],
    _exclusions = [...exclusions];

  markedProducts.forEach(function (product) {
    let mark = false;

    product.tags.forEach(function (tag) {
      _exclusions.forEach(function (exclusion) {
        if (tag.toLowerCase().includes(exclusion.toLowerCase())) {
          mark = true;
        }
      });
    });
    product["excluded"] = mark;
  });

  return markedProducts;
}

// export function disableCareMealProducts(products, tag) {
//   let markedProducts = [...products];

//   markedProducts.forEach(function (product) {
//     product.tags.forEach(function (item) {
//       if (item !== tag) {
//         product.disable = true;
//       } else {
//         product.disable = false;
//       }
//     });
//   });

//   return markedProducts;
// }

export function saveUserSelectionToLocalStorage(state) {
  if (storageAvailable()) {
    let mealConstructorData = JSON.parse(localStorage.getItem(modifyConstructorStorageNamespace));

    if (mealConstructorData === null) {
      mealConstructorData = {
        constructorCart: {},
        selectedMeals: {
          breakfasts: [],
          entrees: [],
        },
      };
    }

    mealConstructorData.constructorCart = { ...state.cart };
    mealConstructorData.dietitian = {
      ...state.dietitian,
    };
    mealConstructorData.selectedExclusions = [...state.selectedExclusions];
    mealConstructorData.selectedMeals = {
      ...state.selectedMeals,
    };
    mealConstructorData.selectedAddIns = [...state.selectedAddIns];
    mealConstructorData.limitations = {
      ...state.limitations,
    };

    mealConstructorData.configPageUrl = state.configPageUrl;
    mealConstructorData.selectedDiet = state.selectedDiet;
    mealConstructorData.programType = state.programType;

    localStorage.setItem(modifyConstructorStorageNamespace, JSON.stringify(mealConstructorData));
  } else {
    logCaptureMessage("Local Storage isn't available");
  }
}

export function pushItemToCartObject(itemsData) {
  let addedProduct = {};
  const { data, type, quantity, SKUs, mealTitles, handles, excludeCodes, freshLean, targetArray } = itemsData;

console.log('itemsData', itemsData)
  if (quantity) {
    data.forEach((item) => {
      item.tags.forEach((tag) => {
        if (tag === type) {
          item.variants.forEach((variant) => {
            if (parseInt(variant.title) === quantity) {
              addedProduct = {
                id: variant.id,
                title: item.title,
                skuList: SKUs,
                mealTitles: mealTitles,
                handles: handles,
                quantity: quantity,
                excludeCodes: excludeCodes,
                freshLean: freshLean,
                price: variant.price,
                selling_plan: getSellingPlan(item.title),
              };
            }
          });
        }
      });
    });
    console.log('addedProduct', addedProduct)
    if (_.isEmpty(addedProduct)) {
      data.forEach((item) => {
        item.tags.forEach((tag) => {
          if (tag === type) {
            addedProduct = {
              id: _.last(item.variants).id,
              title: item.title,
              skuList: SKUs,
              mealTitles: mealTitles,
              handles: handles,
              quantity: quantity,
              excludeCodes: excludeCodes,
              freshLean: freshLean,
              price: item.price,
              selling_plan: getSellingPlan(item.title),
            };
          }
        });
      });
    }
    targetArray.push(addedProduct);
  }
}

export function populateSKUs(data) {
  if (!data.length) return "";
  let SKUs = data.map((item) => item.variants[0].sku + ":" + item.quantity);
  return _.join(SKUs, ",");
}

export function groupExcludeCodes(obj, exclusionSkuPrefix) {
  let codes = [];
  let _exclusions = obj.filter((item) => item.sku.includes(exclusionSkuPrefix));
  _exclusions.forEach((exclusion) => {
    codes.push(exclusion.sku.split(exclusionSkuPrefix)[1]);
  });

  return [...new Set(codes)].join(",");
}

export function setLimits(obj) {
  return obj.limitations !== "undefined"
    ? {
        breakfastsMinLimit: obj.limitations.breakfastsMinLimit,
        entreesMinLimit: obj.limitations.entreesMinLimit,
        additionalMealsMinLimit: {
          breakfastsMinLimit: obj.limitations.additionalMealsMinLimit.breakfastsMinLimit,
          entreesMinLimit: obj.limitations.additionalMealsMinLimit.entreesMinLimit,
        },
      }
    : {
        breakfastsMinLimit: 7,
        entreesMinLimit: 14,
        additionalMealsMinLimit: {
          breakfastsMinLimit: 1,
          entreesMinLimit: 3,
        },
      };
}

export function markHidden(products, state) {
  let markedProducts = [...products],
    _diet = state.selectedDiet;

  markedProducts.forEach(function (product) {
    let mark = true;
    if (_diet === "None") {
      product["hidden"] = false;
    } else {
      product.tags.forEach(function (tag) {
        if (tag.toLowerCase().includes(_diet.toLowerCase())) {
          mark = false;
        }
      });
      product["hidden"] = mark;
    }
  });

  return markedProducts;
}

export function updateNavLink(dietType) {
  const menuItems = document.getElementsByClassName("product__stage-item");
  if (menuItems.length) {
    const links = menuItems[0].getElementsByTagName("a");
    if (links.length) {
      links.item(0).removeEventListener("click", null);
      if (dietType === "Mediterranean Plan") {
        links.item(0).setAttribute("href", "/collections/mediterranean-plan");
      } else if (dietType === "Diabetes Plan") {
        links.item(0).setAttribute("href", "/collections/diabetes-friendly-plan");
      } else if (dietType === "Gluten-Free Plan") {
        links.item(0).setAttribute("href", "/collections/gluten-free-plan");
      } else if (dietType === "Heart-Friendly Plan") {
        links.item(0).setAttribute("href", "/collections/heart-friendly-plan");
      } else if (dietType === "Carb-Conscious Plan") {
        links.item(0).setAttribute("href", "/collections/carb-conscious-plan");
      } else if (dietType === "B2B Plan") {
        links.item(0).setAttribute("href", "/collections/b2b-plan");
      } else if (dietType === "Care Plan") {
        links.item(0).setAttribute("href", "/collections/care-plan");
      }
    }
  }
}

export async function getConstructorModeFromClient() {
  if (storageAvailable()) {
    let localStorageObj = JSON.parse(localStorage.getItem(modifyConstructorStorageNamespace));

    if (localStorageObj !== null) {
      let _limitations = setLimits(localStorageObj);

      return {
        selectedExclusions: typeof localStorageObj.selectedExclusions !== "undefined" ? localStorageObj.selectedExclusions : [],
        configPageUrl: localStorageObj.configPageUrl,
        programType: localStorageObj.programType,
        selectedDiet: localStorageObj.selectedDiet,
        selectedProgram: localStorageObj.selectedDiet,
        dietType: localStorageObj.dietType,
        selectedMeals:
          typeof localStorageObj.selectedMeals !== "undefined"
            ? localStorageObj.selectedMeals
            : {
                breakfasts: [],
                entrees: [],
              },
        selectedAddIns: typeof localStorageObj.selectedAddIns !== "undefined" ? localStorageObj.selectedAddIns : [],
        limitations: _limitations,
        dietitian: localStorageObj.dietitian,
      };
    } else {
      return {
        selectedProgram: "LF-Program",
        selectedDiet: "",
        dietType: "Low-FODMAP Plan",
        programType: "Meals",
        selectedExclusions: [],
        configPageUrl: "",
        dietitian: {
          id: "",
          price: null,
          support: false,
        },
        limitations: {
          breakfastsMinLimit: 7,
          entreesMinLimit: 14,
          additionalMealsMinLimit: {
            breakfastsMinLimit: 0,
            entreesMinLimit: 0,
          },
        },
        constructorCart: {
          bundles: [],
          cartQuantity: 0,
          products: {},
        },
        selectedMeals: {
          breakfasts: [],
          entrees: [],
        },
        selectedAddIns: [],
      };
    }
  } else {
    logCaptureMessage({ message: "Local Storage isn't available" });
    return false;
  }
}

export function populateMealsTitlesAndQuantities(data) {
  if (!data.length) return "";
  let titleList = data.map((item) => item.title + ":" + item.quantity);
  return _.join(titleList, ", ");
}

export function populateMealsHandles(data) {
  if (!data.length) return "";
  let handleList = data.map((item) => item.handle + ":" + item.quantity);
  return _.join(handleList, ",");
}

export function filterExcludeCodes(exclusions, selectedExclusions) {
  return exclusions.filter((exclusion) => {
    let mark = false;
    selectedExclusions.forEach((selectedExclusion) => {
      if (selectedExclusion === exclusion.name) mark = true;
    });

    return mark;
  });
}

export function populateExcludedCodes(exclusions, selectedExclusions, exclusionSkuPrefix) {
  let exclusionData = [];

  selectedExclusions.forEach((selectedExcl) => {
    exclusions.forEach((excl) => {
      if (selectedExcl === excl.name) {
        exclusionData.push(excl.sku.split(exclusionSkuPrefix).pop());
      }
    });
  });

  return {
    excludeCodes: _.join(exclusionData, ","),
    freshLean: "No " + _.join(exclusionData, ",") + ";",
  };
}

export function setSelectedMealsMark(meals, constructorData, constructorObject) {
  let newMeals = _.concat(meals.breakfasts, meals.entrees);

  newMeals.forEach((meal) => {
    constructorData.meals.forEach((mealInner) => {
      if (mealInner.id === meal.id) {
        meal.mealBoughtQuantity = mealInner.mealBoughtQuantity;
        meal.stockCapacity = mealInner.stockCapacity;
      }
    });
  });

  return {
    breakfasts: filterOutMeals(newMeals, ["breakfast"], constructorObject.dietType),
    entrees: filterOutMeals(newMeals, ["entrée"], constructorObject.dietType),
  };
}

export const getFLExcludes = (title) => {
  const FLExclusions =
    title === "Low-FODMAP Plan" ||
    title === "Gluten-Free Plan" ||
    title === "Carb-Conscious Plan" ||
    title === "B2B Plan";
  return FLExclusions;
};

export const getCMExcludes = (title) => {
  return title === "Care Plan";
};
